module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/mtotal0-469b0450b114f83ff9c1e97aea9dbc7c.jpg";